import React from 'react'

const Footer = ({className}) => {
  return (
    <div className={`confidential ${className}`}>
      
    </div>
  )
}

export default Footer
